import React from "react";

const ThemeContext = new React.createContext();

export { ThemeContext };
